enum ProductIssueState {
    Pending = "PENDING",
    Published = "PUBLISHED",
    Rejected = "REJECTED"
}
export default ProductIssueState